import {
	CoachSlotGroupItem,
	CouchGroupByVehicleEnum,
	CouchGroupByVehicles,
} from '@/new-transport/_models/transport-coach-list.model';
import { TransportSide } from '@/new-transport/_models/transport.model';
import { NgClass, JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, ElementRef, input, output, viewChildren } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSortModule, Sort } from '@angular/material/sort';
import { MatRow, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

@Component({
	selector: 'app-transport-coach-table',
	standalone: true,
	imports: [MatTableModule, NgClass, MatSortModule, MatTooltipModule, RouterModule, JsonPipe, MatButtonModule],
	templateUrl: './transport-coach-table.component.html',
	styleUrl: './transport-coach-table.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportCoachTableComponent {
	readonly TransportSide = TransportSide;

	// inputs
	readonly dataSource = input.required<CoachSlotGroupItem[]>();
	readonly highlightedSlotIds = input.required<Set<number>>();
	readonly selectedDataToUpdate = input.required<{
		activeCoach: CouchGroupByVehicles;
		seatId: number;
		selectedSlot: CoachSlotGroupItem;
	}>();
	readonly displayedColumns = input.required<string>();
	readonly transportSide = input.required<TransportSide>();

	readonly CouchGroupByVehicleEnum = CouchGroupByVehicleEnum;

	// outputs
	readonly chooseSlotChange = output<CoachSlotGroupItem>();
	readonly onSortChange = output<Sort>();
	readonly removeSeatEmit = output<CoachSlotGroupItem>();
	readonly rowsReady = output<ElementRef[]>();

	private readonly rowElements = viewChildren(MatRow, { read: ElementRef });

	constructor() {
		effect(() => {
			this.rowsReady.emit([...this.rowElements()]);
		});
	}
}
